module.exports = __webpack_public_path__ + "static/img/RAMBAUDI.17e47fd2.png";